import{keyframes as i,styled as t,modifier as n,css as a}from"@lokalise/styled";const o=i`
    0% {
        opacity: .3;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: .3;
    }
`,e=t.div.withConfig({displayName:"Skeleton__Container",componentId:"sc-19dwa64-0"})(["width:100%;",""],n("$animated",a`
			animation-name: ${o};
			animation-duration: 1.5s;
			animation-iteration-count: infinite;
		`));export{e as Container};
//# sourceMappingURL=styles.js.map
